import { Button, Input, message, Space, Table } from "antd";
import { useEffect, useRef, useState } from "react";
import { serverFetch } from "../../server";
import Client from "../clients/client";
import { fmtDate } from "../../extensions/utils";
import { isMobile } from "../../extensions/design";
import VisitItem from "./visit-item";

const VisitClientSelect = ({ onSelect, onCancel }) => {
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [newClient, setNewClient] = useState(false);
  // Создаем реф для нужного контрола
  const specialInputRef = useRef(null);
  const isSpecialInputFocused = useRef(false);
  const searchRef = useRef(null);
  searchRef.current = search;

  useEffect(() => {
    if (specialInputRef.current) specialInputRef.current.focus();
    const handleKeyDown = (e) => {
      // Проверяем, что нажат Enter и наш контрол в фокусе
      if (e.key === 'Enter' && isSpecialInputFocused.current) {
        e.preventDefault(); // Предотвращаем стандартное поведение
        getData();
      }
    };
    // Добавляем обработчик на весь документ
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  const columns = [
    { dataIndex: "name", label: "ФИО", },
    { dataIndex: "dateBirth", label: "Дата р.", render: fmtDate },
    { dataIndex: "phone", label: "Телефон", },
  ]

  const getData = () => {
    setLoading(true);
    console.log(searchRef.current)
    serverFetch(`client?searchText=${encodeURIComponent(searchRef.current)}`)
      .then(data => {
        setItems(data);
        console.log(data)
        setLoading(false);
        if (data.length === 1) onSelect(data[0].id);
      })
      .catch(e => {
        message.error(e.userMessage);
        setLoading(false);
      });
  }

  const onNewClient = (refresh, id) => {
    setNewClient(false);
    refresh && onSelect(id);
  }

  return<div className="sport-section">
    {newClient && <Client id={0} onClose={onNewClient} />}
    <div className="sport-section-row">
      {!isMobile ? 
        <Space>
          <div>Поиск клиента</div>
          <Input 
            placeholder="Телефон, карта, ФИО"
            value={search}
            onChange={e => setSearch(e.target.value)}
            ref={specialInputRef}
            onFocus={() => isSpecialInputFocused.current = true}
            onBlur={() => isSpecialInputFocused.current = false}
            allowClear
          /> 
          <Button onClick={getData} disabled={loading}>Найти</Button>
          <Button onClick={() => setNewClient(true)}>Новый</Button>
          <Button onClick={onCancel}>Отмена</Button>
        </Space> :
        <div className="visits-triple-search-container">
          <Input
            placeholder="Телефон, карта, ФИО"
            value={search}
            onChange={e => setSearch(e.target.value)}
            ref={specialInputRef}
            onFocus={() => isSpecialInputFocused.current = true}
            onBlur={() => isSpecialInputFocused.current = false}
            allowClear
          /> 
          <Button className="visits-buttons-search" onClick={getData} disabled={loading}>Найти</Button>
          <Button className="visits-buttons-search" onClick={() => setNewClient(true)}>Новый</Button>
        </div>
      }
    </div>
    { !isMobile ? 
      <Table dataSource={items} rowKey="id" columns={columns} size="small" pagination={false} onRow={(record) => ({onClick: () => {onSelect(record.id)}})}/> :
      (<div className="visit-cleint-select-list-of-visits">
      {items.map((item) => {
        let imgElement;
        if (item.imageId) {
          imgElement = (<img src={`${process.env.REACT_APP_API_BASE_URL}/api/image/${item.imageId}.jpg`} alt="client" className={ isMobile ? "client-image" : ""} style={{ margin: -4 }}/>);
        } else {
          const icon = item.card ? '/images/card.svg' : '/images/mask.svg';
          imgElement = <img src={icon} alt="client" />;
        }
        return (
          <div className="visit-item" style={{marginBottom: "4px"}} key={item.id} onClick={() => onSelect(item.id)}>
            <div className={ !isMobile ? "visit-item-photo" : "client-item-photo"}>{imgElement}</div>
            <div className="visit-item-body" style={{ flex: 1, minWidth: 0 }}>
              <div className="visit-item-line1" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                <div style={{ fontWeight: 600, flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}> {item.name} </div>
                <div style={{ textAlign: 'center', fontWeight: 600, flex: '0 0 60px' }}>
                  {new Date(item.createdOn).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </div>
              </div>
              <div className="visit-item-line2" style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.875em' }}>
                <div>#{item.id}</div>
                <div className="vitis-item-clip" style={{  flex: 1, minWidth: 0, margin: '0 8px', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'center'}}>
                  {item.card || '—'}
                </div>
                <div style={{ textAlign: 'center', flex: '0 0 80px' }}> {item.phone || '—'} </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>)
    }
    
  </div>
}

export default VisitClientSelect;